import { initializeNutasticApp } from '@nutastic/nutastic-react-app';
import AppLoading from './components/AppLoading';
import App from './components/App';
import WebFont from 'webfontloader';
import messages from './i18n/messages';
import websiteReducer from './state/reducer.mjs';
import initAppData from './utils/initAppData.mjs';
import { getFromLocalStorage, saveToLocalStorage } from './utils/localStorageHelper';
import { CONSTANTS } from './utils/constants';

const init = async () => {
    WebFont.load({
        google: {
            families: [
                'Nanum+Myeongjo:wght@400;700',
                'Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,900'
            ]
        }
    });

    let recentVideos = getFromLocalStorage({ key: CONSTANTS.APPKEY_RECENT_VIDEOS, useJson: true }) || [];
    let recentMusic = getFromLocalStorage({ key: CONSTANTS.APPKEY_RECENT_MUSIC, useJson: true }) || [];
    //merge from database if present (recent storage is cleared on logout and login)
    if(window.hasOwnProperty('nutasticAppConfig')) {
        if (window.nutasticAppConfig.hasOwnProperty('recentVideos')) {
            const dbRecVideos = window.nutasticAppConfig.recentVideos || [];
            dbRecVideos.forEach(i => {
                if (!recentVideos.find(x => x.id === i.id)) {
                    recentVideos.push(i);
                }
            });
        }
        if (window.nutasticAppConfig.hasOwnProperty('recentMusic')) {
            const dbRecMusic = window.nutasticAppConfig.recentMusic || [];
            dbRecMusic.forEach(i => {
                if (!recentMusic.find(x => x.id === i.id)) {
                    recentMusic.push(i);
                }
            });
        }
    }

    console.log('initializing page');
    await initializeNutasticApp({
        AppComponent: App,
        LoadingComponent: AppLoading,
        initialState: {
            recentVideos,
            recentMusic
        },
        decorateStateFn: initAppData,
        loadingDelay: 1000,
        messages,
        reducers: [websiteReducer]
    });
};

init();
